export class SearchModule {

	constructor(menuModule) {
		this.$trigger = $("[data-search-trigger]");
		this.$action = $("[data-search-action]");
		this.menuModule = menuModule;
		this.init();
	}

	init() {
		this.$trigger.on('click', (e) => { this.toggleSearchForm() });
		this.$action.find("form").on('submit', (e) => { this.handleFormSubmission(e) });
	}

	/**
	 * Prevent formsubmission with empty form or whitespace only
	 * Trim whitespace and update value to trimmed string
	 */
	handleFormSubmission(e) {
		let $input = $(e.currentTarget).find("input[type='search']");
		let trimmedVal = $input.val().trim();

		if (!trimmedVal.length) {
			e.preventDefault();
		}
		$input.val(trimmedVal);
	}

	toggleSearchForm() {
		if (this.searchFormIsOpen()) {
			this.closeSearchForm();
		} else {
			this.openSearchForm();
		}
		this.closeMobileMenu();
	}

	searchFormIsOpen() {
		return this.$action.hasClass('active');
	}

	closeSearchForm() {
		this.$trigger.removeClass('active');
		this.$action.removeClass('active');
		$("body").off('.ipcosearch');
	}

	openSearchForm() {
		this.$trigger.addClass('active');
		this.$action.addClass('active');
		this.addFocusToInput();

		$("body").on('focus.ipcosearch', 'a,input,button,[tabindex]', (e) => { this.closeSearchIfOutsideAction(e) });
		$("body").on('click.ipcosearch', (e) => { this.closeSearchIfOutsideAction(e) });
	}

	addFocusToInput() {
		this.$action.find("input[type='search']").focus();
	}

	closeMobileMenu() {
		if (this.menuModule.hasOpenMenu()) {
			this.menuModule.toggleMenu();
		}
	}

	/**
	 * close searchform if focus or click outside of searchelements
	 */
	closeSearchIfOutsideAction(e) {
		if ($(e.target).closest('[data-search-action]').length || $(e.target).closest('[data-search-trigger]').length) {
			//inside form or inside triggerwrapper. Let mainevt handle
			return;
		}
		this.closeSearchForm();
	}

}
